<ion-header>
  <ion-toolbar color="light">
    <ion-buttons slot="start">
      <ion-menu-button>
        <ion-icon class="icon-menu" color="dark" name="menu"></ion-icon>
        <app-inbox-count></app-inbox-count>
      </ion-menu-button>
    </ion-buttons>
    <ion-title>
      <app-offline-indicator></app-offline-indicator>
      {{ 'MENU.accountTask' | translate }}
    </ion-title>
  </ion-toolbar>
</ion-header>
<ion-content color="light">
  <div class="content-div">
    <ion-grid>
      <ion-row class="ion-justify-content-center">
        <ion-col class="ion-align-self-center" size="6" *ngIf="privilege?.['setup_visitor_page']">
          
          <ion-card class="ion-text-center ion-no-margin box-shadow" [color]="status?.['setup_visitor_page'] ? 'success' : 'white'">
            <div>
              <ion-button class="btn-help ion-no-padding ion-no-margin" fill="clear" color="dark" (click)="goChecklistHelp('setup_visitor_page')">
                <ng-container *ngIf="true then helpIconBlock"></ng-container>
              </ion-button>
              <ion-img class="img" src="./assets/wedding/img/account-task/visitor_page.svg"></ion-img>
              <ion-label class="task-lbl font-14 font-semi ion-text-wrap">{{ 'CHECKLIST.setup_visitor.title' | translate }}</ion-label>
              <div class="task-msg"><ion-text class="font-10 ion-text-wrap" [innerHtml]="replaceEventType('CHECKLIST.setup_visitor.msg' | translate)"></ion-text></div>
              <ion-button size="large" shape="round" *ngIf="!status?.['setup_visitor_page'] else doneBtnBlock" (click)="goChecklistAction('setup_visitor_page')">{{ 'BTN.go' | translate }}</ion-button>
            </div>
          </ion-card>
        </ion-col>
        <ion-col class="ion-align-self-center" size="6" *ngIf="privilege?.['add_guest']">
          
          <ion-card class="ion-text-center ion-no-margin box-shadow" [color]="status?.['add_guest'] ? 'success' : 'white'">
            <div>
              <ion-button class="btn-help ion-no-padding ion-no-margin" fill="clear" color="dark" (click)="goChecklistHelp('add_guest')">
                <ng-container *ngIf="true then helpIconBlock"></ng-container>
              </ion-button>
              <ion-img class="img" src="./assets/wedding/img/account-task/new_guest.svg"></ion-img>
              <ion-label class="task-lbl font-14 font-semi ion-text-wrap">{{ 'MODULE.action.guest.new' | translate }}</ion-label>
              <div class="task-msg"><ion-text class="font-10 ion-text-wrap" [innerHtml]="replaceEventType('CHECKLIST.new_guest.msg' | translate)"></ion-text></div>
              <ion-button size="large" shape="round" *ngIf="!status?.['add_guest'] else doneBtnBlock" (click)="goChecklistAction('add_guest')">{{ 'BTN.go' | translate }}</ion-button>
            </div>
          </ion-card>
        </ion-col>
        <ion-col class="ion-align-self-center" size="6" *ngIf="privilege?.['send_qr']">
          <ion-card class="ion-text-center ion-no-margin box-shadow" [color]="status?.['send_qr'] ? 'success' : 'white'">
            <div>
              <ion-button class="btn-help ion-no-padding ion-no-margin" fill="clear" color="dark" (click)="goChecklistHelp('send_qr')">
                <ng-container *ngIf="true then helpIconBlock"></ng-container>
              </ion-button>
              <ion-img class="img" src="./assets/wedding/img/account-task/send_qr.svg"></ion-img>
              <ion-label class="task-lbl font-14 font-semi ion-text-wrap">{{ 'QRCODE.btn.send' | translate }}</ion-label>
              <div class="task-msg"><ion-text class="font-10 ion-text-wrap" [innerHtml]="replaceEventType('CHECKLIST.send_qr.msg' | translate)"></ion-text></div>
              <ion-button size="large" shape="round" *ngIf="!status?.['send_qr'] else doneBtnBlock" (click)="goChecklistAction('send_qr')">{{ 'BTN.go' | translate }}</ion-button>
            </div>
          </ion-card>
        </ion-col>
        <ion-col class="ion-align-self-center" size="6" *ngIf="privilege?.['invite_member']">
          <ion-card class="ion-text-center ion-no-margin box-shadow" [color]="status?.['invite_member'] ? 'success' : 'white'">
            <div>
              <ion-button class="btn-help ion-no-padding ion-no-margin" fill="clear" color="dark" (click)="goChecklistHelp('invite_member')">
                <ng-container *ngIf="true then helpIconBlock"></ng-container>
              </ion-button>
              <ion-img class="img" src="./assets/wedding/img/account-task/invite_member.svg"></ion-img>
              <ion-label class="task-lbl font-14 font-semi ion-text-wrap">{{ 'ACCOUNT_SHARE.lbl.invite_member' | translate }}</ion-label>
              <div class="task-msg"><ion-text class="font-10 ion-text-wrap" [innerHtml]="replaceEventType('CHECKLIST.invite_member.msg' | translate)"></ion-text></div>
              <ion-button size="large" shape="round" *ngIf="!status?.['invite_member'] else doneBtnBlock" (click)="goChecklistAction('invite_member')">{{ 'BTN.go' | translate }}</ion-button>
            </div>
          </ion-card>
        </ion-col>
        <ion-col class="ion-align-self-center" size="6" *ngIf="privilege?.['assign_seating']">
          <ion-card class="ion-text-center ion-no-margin box-shadow" [color]="status?.['assign_seating'] ? 'success' : 'white'">
            <div>
              <ion-button class="btn-help ion-no-padding ion-no-margin" fill="clear" color="dark" (click)="goChecklistHelp('assign_seating')">
                <ng-container *ngIf="true then helpIconBlock"></ng-container>
              </ion-button>
              <ion-img class="img" src="./assets/wedding/img/account-task/assign_seating.svg"></ion-img>
              <ion-label class="task-lbl font-14 font-semi ion-text-wrap">{{ 'SEATING.btn.assign' | translate: { seating: seatingTypeName } }}</ion-label>
              <div class="task-msg"><ion-text class="font-10 ion-text-wrap" [innerHtml]="replaceEventType('CHECKLIST.assign_seating.msg' | translate)"></ion-text></div>
              <ion-button size="large" shape="round" *ngIf="!status?.['assign_seating'] else doneBtnBlock" (click)="goChecklistAction('assign_seating')">{{ 'BTN.go' | translate }}</ion-button>
            </div>
          </ion-card>
        </ion-col>
        <ion-col class="ion-align-self-center" size="6" *ngIf="privilege?.['review_setting']">
          <ion-card class="ion-text-center ion-no-margin box-shadow" [color]="status?.['review_setting'] ? 'success' : 'white'">
            <div>
              <ion-button class="btn-help ion-no-padding ion-no-margin" fill="clear" color="dark" (click)="goChecklistHelp('review_setting')">
                <ng-container *ngIf="true then helpIconBlock"></ng-container>
              </ion-button>
              <ion-img class="img" src="./assets/wedding/img/account-task/review_setting.svg"></ion-img>
              <ion-label class="task-lbl font-14 font-semi ion-text-wrap">{{ 'CHECKLIST.review_setting.title' | translate }}</ion-label>
              <div class="task-msg"><ion-text class="font-10 ion-text-wrap" [innerHtml]="replaceEventType('CHECKLIST.review_setting.msg' | translate)"></ion-text></div>
              <ion-button size="large" shape="round" *ngIf="!status?.['review_setting'] else doneBtnBlock" (click)="goChecklistAction('review_setting')">{{ 'BTN.go' | translate }}</ion-button>
            </div>
          </ion-card>
        </ion-col>
        <ion-col class="ion-align-self-center" size="6" *ngIf="privilege?.['checkin_guest']">
          <ion-card class="ion-text-center ion-no-margin box-shadow" [color]="status?.['checkin_guest'] ? 'success' : 'white'">
            <div>
              <ion-button class="btn-help ion-no-padding ion-no-margin" fill="clear" color="dark" (click)="goChecklistHelp('checkin_guest')">
                <ng-container *ngIf="true then helpIconBlock"></ng-container>
              </ion-button>
              <ion-img class="img" src="./assets/wedding/img/account-task/checkin_guest.webp"></ion-img>
              <ion-label class="task-lbl font-14 font-semi ion-text-wrap">{{ 'MENU.checkin' | translate }}</ion-label>
              <div class="task-msg"><ion-text class="font-10 ion-text-wrap" [innerHtml]="replaceEventType('CHECKLIST.checkin_guest.msg' | translate)"></ion-text></div>
              <ion-button size="large" shape="round" *ngIf="!status?.['checkin_guest'] else doneBtnBlock" (click)="goChecklistAction('checkin_guest')">{{ 'BTN.go' | translate }}</ion-button>
            </div>
          </ion-card>
        </ion-col>
        <ion-col class="ion-align-self-center" size="6" *ngIf="privilege?.['record_gift']">
          <ion-card class="ion-text-center ion-no-margin box-shadow" [color]="status?.['record_gift'] ? 'success' : 'white'">
            <div>
              <ion-button class="btn-help ion-no-padding ion-no-margin" fill="clear" color="dark" (click)="goChecklistHelp('record_gift')">
                <ng-container *ngIf="true then helpIconBlock"></ng-container>
              </ion-button>
              <ion-img class="img" src="./assets/wedding/img/account-task/record_gift.webp"></ion-img>
              <ion-label class="task-lbl font-14 font-semi ion-text-wrap">{{ replaceEventType('CHECKLIST.record_gift.title' | translate) }}</ion-label>
              <div class="task-msg"><ion-text class="font-10 ion-text-wrap" [innerHtml]="replaceEventType('CHECKLIST.record_gift.msg' | translate)"></ion-text></div>
              <ion-button size="large" shape="round" *ngIf="!status?.['record_gift'] else doneBtnBlock" (click)="goChecklistAction('record_gift')">{{ 'BTN.go' | translate }}</ion-button>
            </div>
          </ion-card>
        </ion-col>
      </ion-row>
    </ion-grid>
  </div>
</ion-content>

<ng-template #doneBtnBlock>
  <ion-button size="large" shape="round" color="light">{{ 'LBL.completed' | translate }}</ion-button>
</ng-template>

<ng-template #helpIconBlock>
  <ion-icon class="font-24" slot="icon-only" name="help-circle-outline"></ion-icon>
</ng-template>